const MONTHLY_STATE_KEY = 'monthlyReconciliation.detailState';
const MONTHLY_RESTORE_INTENT_KEY = 'monthlyReconciliation.restoreIntent';
const MONTHLY_RESTORE_INTENT_MAX_AGE_MS = 15 * 60 * 1000;

const getSession = () => (typeof window !== 'undefined' ? window.sessionStorage : null);

export function writeMonthlyState(state) {
  const session = getSession();
  if (!session || !state || typeof state !== 'object') return;

  try {
    session.setItem(MONTHLY_STATE_KEY, JSON.stringify(state));
  } catch (_) {
    // Ignore serialization or quota failures.
  }
}

export function readMonthlyState() {
  const session = getSession();
  if (!session) return null;

  try {
    const raw = session.getItem(MONTHLY_STATE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);

    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
  } catch (_) {
    return null;
  }
}

export function setMonthlyRestoreIntent() {
  const session = getSession();
  if (session) session.setItem(MONTHLY_RESTORE_INTENT_KEY, String(Date.now()));
}

export function isMonthlyRestoreIntentActive() {
  const session = getSession();
  if (!session) return false;

  const raw = session.getItem(MONTHLY_RESTORE_INTENT_KEY);
  if (!raw) return false;

  const timestamp = Number(raw);

  return Number.isFinite(timestamp) && timestamp > 0 && Date.now() - timestamp <= MONTHLY_RESTORE_INTENT_MAX_AGE_MS;
}

export function clearMonthlyRestoreIntent() {
  const session = getSession();
  if (session) session.removeItem(MONTHLY_RESTORE_INTENT_KEY);
}

export function getRestoredMonthlyState() {
  if (!isMonthlyRestoreIntentActive()) return null;

  return readMonthlyState();
}
